import { Component, OnInit, Optional, Inject } from '@angular/core';
import { EditDialogsWsdefsService } from './edit-dialogs-wsdefs.service';
import { DialogsAlertComponent } from '../../../../../../../shared/components/dialogs/dialogs-alert/dialogs-alert.component';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import * as _ from 'lodash';
import { Xmldefs } from 'src/app/core/entities/xmldefs.model';
import { Utils } from 'src/app/core/utils/utils';
import { CampsComponent } from '../../../xmldefs/camps/camps.component';

@Component({
  selector: 'app-edit-dialogs-wsdefs',
  templateUrl: './edit-dialogs-wsdefs.component.html',
  styleUrls: ['./edit-dialogs-wsdefs.component.scss']
})
export class EditDialogsWsdefsComponent implements OnInit {

  /** Subscripción para el guardado de un wsdef */
  $guardar!: Subscription;

  loading: boolean = true;
  defaultLabel: string = "";
  selectedItemsLabel: string = "";
  styleFormat = {width: '100%'};

  constructor(@Optional() @Inject(MAT_DIALOG_DATA) public data: any,
              public editDialogsWsdefsService: EditDialogsWsdefsService,
              @Optional() private dialogRef: MatDialogRef<EditDialogsWsdefsComponent>,
              private translateService: TranslateService,
              private dialog: MatDialog) { this.editDialogsWsdefsService.build(); }

  ngOnInit() {
    this.editDialogsWsdefsService.init(this.data).subscribe(result => {
      this.loading = false;
    });
    this.selectedItemsLabel = this.translateService.instant('selectedItemsLabel');
  }

  /**
  * @description
  * Guardar el Wsdefs
  */
  guardar() {
    this.loading = true;
    this.$guardar = this.editDialogsWsdefsService.guardar().subscribe(value => {
      console.log(value);
      // -2: El número del wsdef está ausente
      // -1: El número del wsdef ya existe
      // false: Error al guardar
      if (value === -1 || value === false || value === -2) {
        this.errorWsdefs('WARNINGS.error_nuevo');
      }
      this.loading = false;
    }, error => {
      console.log(error);
      this.errorWsdefs('WARNINGS.error_nuevo');
      this.loading = false;
    });
  }

  /**
  * @description
  * Cierra el dialog wsdefs
  */
  aceptar() {
    this.dialogRef.close(true);
  }

  /**
  * @description
  * Deshabilita o habilita el botón aceptar
  */
  deshabilitar(){
    let wsdef = this.editDialogsWsdefsService.wsdefs;
    let original = this.editDialogsWsdefsService.originalWsdefs;
    return this.editDialogsWsdefsService.compare(wsdef, original);
  }

  /**
  * @description
  * Abre un cuadro de dialogo para informar de un error
  * @param error Texto a mostrar
  */
  public errorWsdefs(error: string) {
    const dialogRef = this.dialog.open(DialogsAlertComponent, {
      disableClose: true,
      hasBackdrop: true,
      data: { texto: this.translateService.instant(error) }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
    });
  }

  /**
  * @description
  * Abre el dialog para modificar un camps
  * @param xmldef Opcional. Xmldef.
  */
  public campsXmldef(xmldef?: Xmldefs) {
    Utils.toggleAllButtonsAndHref(true);
    let titulochange = true;
    console.log(xmldef);
    const dialogRef = this.dialog.open(CampsComponent, {
      width: '85%',
      disableClose: true,
      hasBackdrop: true,
      data: { xmldef, titulochange }
    });
    Utils.accessibilityDialogCdk();
    dialogRef.afterClosed().subscribe((result: Xmldefs) => {
      Utils.toggleAllButtonsAndHref(false);
      console.log(result);
    });
  }

}
